export default __webpack_public_path__ + "images/paper_q80.webp";